import React, { useEffect, useState, useRef } from "react";
import * as styles from "./access.css.ts";

const Access: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.5 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section ref={sectionRef} className={styles.container} id="access">
      <div className={`${styles.content} ${isVisible ? styles.animate : ""}`}>
        <div className={styles.textContent}>
          <h2 className={styles.title}>Access</h2>
          <div className={styles.description}>
            <p>〒040-0081 北海道函館市田家町２０−１５</p>
            <p>TEL：090-4962-6601</p>
            <p>完全予約制</p>
            <p>昼営業日：11:00〜15:00（L.O. 14:30）</p>
            <p>夜営業日：18:30〜22:00（L.O. 21:00）</p>
            <p>五稜郭駅から徒歩10分</p>
          </div>
        </div>
        <div className={styles.mapWrapper}>
          <iframe 
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2974.3311843367524!2d140.73970437675663!3d41.79962547125045!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5f9ef500462de981%3A0x5e0ec4e249af09c5!2zS2l0Y2hlbiBNw7xrw7wo44Kt44OD44OB44Oz44Og44KvKQ!5e0!3m2!1sja!2sjp!4v1741776257241!5m2!1sja!2sjp"
            width="600"
            height="450"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            className={styles.map}
          />
        </div>
      </div>
    </section>
  );
};

export default Access; 